/**
 * EDI申請取込
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.ADMIN_ENDPOINT}/settings/edi_requests`

 const setting_edi_request = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params, {headers: {'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },

    /**
     * EDI情報紐付け登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    register ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(`${API_PATH}/edi_registrations`, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    // /**
    //  * 排出事業者一覧取得
    //  * @param commit
    //  * @param emission_request_ids
    //  * @return {Promise<unknown>}
    //  */
    // fetchEmissions ({ commit }, { emission_request_ids }) {
    //   const params = {
    //     emission_request_ids: emission_request_ids
    //   }
    //   return new Promise( ( resolve, reject ) => {
    //     Vue.$http.get(`${API_PATH}/emissions`, { params }).then( data => {
    //       let content = data.content
    //       resolve(content)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

  },
  mutations: {
  },
}

export default setting_edi_request
